import {
  Layout,
  LegacyCard,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage as PolarisSkeletonPage,
  TextContainer,
} from '@shopify/polaris'
import React from 'react'

import { MailType } from '../settings-page/NotificationsCard'
import { pageTitles } from './MailSettingsPage'
import { VariablesCard } from './VariablesCard'

interface Props {
  mailType: MailType
}

export const SkeletonPage = (props: Props) => (
  <PolarisSkeletonPage title={pageTitles[props.mailType]} backAction>
    <Layout>
      <Layout.Section>
        <LegacyCard sectioned>
          <TextContainer>
            <SkeletonDisplayText size="small" />
            <SkeletonBodyText />
          </TextContainer>
        </LegacyCard>
      </Layout.Section>
      <Layout.Section variant="oneThird">
        <VariablesCard mailType={props.mailType} />
      </Layout.Section>
    </Layout>
  </PolarisSkeletonPage>
)
